import { clubGiftsGaloreAssets } from "assets/cdn";
import { useImagePath } from "hooks";
import useRewardsById from "hooks/useRewardsById";
import React from "react";
import {
	CrossOutLine,
	CrossOutValue,
	NumberValue,
	Reward,
	RewardIcon,
	StarBurst
} from "../../styles";

interface RewardItemProps {
	reward: { id: string };
	filteredRewardsLength: number;
	offerRewardCrossout?: string | number;
	isHighlightReward?: boolean;
}

const RewardItem: React.FC<RewardItemProps> = ({
	reward,
	filteredRewardsLength,
	offerRewardCrossout,
	isHighlightReward
}) => {
	const { getImage } = useImagePath("cdn");
	const starBurst = getImage(clubGiftsGaloreAssets.v1.giftBoxes.starBurst);
	const rewardsById = useRewardsById(reward.id)?.[0];

	return (
		<Reward key={reward.id}>
			<RewardIcon
				src={rewardsById?.imageUrl}
				className={filteredRewardsLength >= 2 ? "small-items" : ""}
			/>
			<NumberValue style={{ paintOrder: "stroke fill" }}>
				{rewardsById?.description}
			</NumberValue>
			{offerRewardCrossout && (
				<CrossOutValue className="reward">
					<CrossOutLine className="reward" />
					{offerRewardCrossout && <>{offerRewardCrossout}</>}
				</CrossOutValue>
			)}
			{isHighlightReward && <StarBurst src={starBurst}></StarBurst>}
		</Reward>
	);
};

export default RewardItem;
